module.exports = { id: "shop", url: "/build/app/img/symbols.svg#shop", viewBox: "", toString: function() { return this.url; } };